import React from 'react';

import { Alert, AlertTitle, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import useCanAccessLeLens from '~/hooks/useCanAccessLeLens';

type LensAccessGateProps = { children: React.ReactNode };

export default function LensAccessGate({ children }: LensAccessGateProps) {
  const canAccess = useCanAccessLeLens();

  if (!canAccess) {
    return (
      <Container>
        <PageHeader title="LE Lens" />
        <Alert severity="warning">
          <AlertTitle>LE Lens is currently in closed beta</AlertTitle>
          For access, reach out to the data platform team (data@luxuryescapes.com).
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
